// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChooseAFlight {
  min-height: 600px;
  width: 100%;
}
.ChooseAFlight .planeCarousel {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ChooseAFlight .disable-amt-container {
  width: 40%;
}
.ChooseAFlight .show-main-summary {
  visibility: visible;
}
.ChooseAFlight .show-phn-summary {
  display: none;
}
.ChooseAFlight .disabled-aircraft {
  margin-top: 70px;
}
.ChooseAFlight .disabled-aircraft .details-container {
  display: flex;
  width: 100%;
  max-width: 968px;
  margin: -15px auto 30px;
}
.ChooseAFlight .disabled-aircraft .info-container {
  margin: 0 auto;
}
.ChooseAFlight .flight-info {
  width: 100%;
  max-width: 1080px;
  margin: 2% auto 4%;
  display: flex;
}
.ChooseAFlight .jet-desc {
  color: #2C3034;
  margin: 42px auto 0 auto;
  width: 35%;
  text-align: center;
}
.ChooseAFlight .jet-desc .desc-header {
  display: inline-block;
  padding: 0 1%;
  width: 100%;
}
.ChooseAFlight .jet-desc .desc-header-left {
  height: 7.76px;
  float: left;
  width: 31%;
}
.ChooseAFlight .jet-desc .desc-header-left img {
  width: -webkit-fill-available;
}
.ChooseAFlight .jet-desc .desc-header-mid {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  margin: -5px 5px 0 5px;
  float: left;
  width: 33%;
}
.ChooseAFlight .jet-desc .desc-header-right {
  height: 7.76px;
  float: right;
  width: 31%;
}
.ChooseAFlight .jet-desc .desc-header-right img {
  width: -webkit-fill-available;
}
.ChooseAFlight .jet-desc .desc-body {
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding: 20px 12px 12px 12px;
}
.ChooseAFlight .jet-desc .desc-feat {
  position: relative;
  display: flex;
  margin-top: 25px;
  padding: 0px 70px 0px 70px;
}
.ChooseAFlight .jet-desc .desc-feat .f-icons {
  width: 50%;
  height: 22px;
  filter: invert(0%) brightness(0%);
}
.ChooseAFlight .jet-desc .desc-feat .f-icons span {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-left: 10px;
}
.ChooseAFlight .jet-img {
  width: 70%;
  margin: auto;
}
.ChooseAFlight .jet-img img {
  width: 100%;
}
.ChooseAFlight .load_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.ChooseAFlight .ld_mr {
  margin: 25px auto;
}
.ChooseAFlight .load_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.ChooseAFlight .no-flight-msg {
  margin: auto;
  font-size: 22px;
}
.ChooseAFlight button.loadMore {
  display: flex;
  justify-content: center;
  padding: 8px;
  border-radius: 70px;
  height: 42px;
  background-color: #ffffff;
  border: 1px solid #3881ef;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #694779;
  padding: 14px 30px;
  height: 64px;
  background: #ffffff;
  border: 1px solid #694779;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.15);
  border-radius: 140px;
  letter-spacing: 0.4px;
}
.ChooseAFlight .general-btn {
  border: 0;
  border-radius: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 500;
}
.ChooseAFlight .plane-meta {
  width: 968px;
  display: flex;
  margin: 10px auto auto;
}
.ChooseAFlight .plane-meta button.blue-btn {
  float: right;
}
.ChooseAFlight .tripsummary-fixed {
  position: fixed;
  top: 0;
  z-index: 2;
}
.ChooseAFlight .details-container {
  width: 350px;
  max-width: 968px;
}
.ChooseAFlight .details-container .title-contact {
  font-size: 35px !important;
  font-weight: 600;
}
.ChooseAFlight .details-container .info-container {
  margin: 0 auto;
}
.ChooseAFlight .details-container .info-container .unavailable {
  margin-bottom: 30px;
  border-radius: 24px;
  background-color: #848b94;
  padding: 20px 20px;
}
.ChooseAFlight .details-container .info-container .unavailable .info-text {
  color: #fff;
  font-size: 15px;
}
.ChooseAFlight .details-container .info-container .unavailable .header {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
}
.ChooseAFlight .details-container .info-container .unavailable .header .icon {
  align-self: center;
}
.ChooseAFlight .details-container .info-container .unavailable .header .title {
  font-size: 35px !important;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0;
  padding-left: 10px;
  font-family: "FKGroteskNeue-Medium";
}
.ChooseAFlight .details-container .info-container .info-text {
  font-weight: normal;
}
.ChooseAFlight .details-container .amount-containers {
  margin-left: 133px;
}
.ChooseAFlight .ApplicationTab .tab-container {
  width: 95%;
  max-width: 968px;
}
.ChooseAFlight .good-deal-modal > img {
  width: 100%;
}
.ChooseAFlight .good-deal-modal > .plane-type {
  text-align: center;
  font-size: 25px;
  font-weight: bold;
}
.ChooseAFlight .good-deal-modal > button {
  display: flex;
  align-items: center;
  margin: 30px auto auto;
}
.ChooseAFlight .good-deal-modal > .info-text {
  color: #848b94;
  width: 70%;
  text-align: center;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 50px;
}
.ChooseAFlight .good-deal-modal > .info-text-recommended {
  color: #848b94;
  width: 85%;
  text-align: center;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 50px;
}
.ChooseAFlight .Modal .modal-content {
  border-radius: 8px;
}

.ChooseAFlightHeader {
  color: #fff;
  padding-bottom: 48px;
}
.ChooseAFlightHeader > .head-title {
  width: 95%;
  max-width: 968px;
  margin: auto;
  margin-bottom: auto;
  margin-bottom: 43px;
  font-size: 72px;
  line-height: 80px;
}
.ChooseAFlightHeader > .route-info-container {
  width: 95%;
  max-width: 968px;
  margin: auto;
  background-color: #694779;
  padding: 20px;
  border-radius: 24px;
  display: flex;
  cursor: pointer;
}
.ChooseAFlightHeader > .route-info-container > .panel-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ChooseAFlightHeader > .route-info-container > .panel-icon-box > .panel-icon-flight-vector {
  width: 18px !important;
  height: 16px !important;
}
.ChooseAFlightHeader > .route-info-container > .panel-icon-box > .panel-icon-flight-vector > img {
  display: block;
  width: 100%;
  object-fit: cover;
}
.ChooseAFlightHeader > .route-info-container > .panel-icon-box .panel-icon-edit-vector {
  width: 16px !important;
  height: 16px !important;
}
.ChooseAFlightHeader > .route-info-container > .panel-icon-box .panel-icon-edit-vector > img {
  display: block;
  width: 100%;
  object-fit: cover;
}
.ChooseAFlightHeader > .route-info-container .grey-edit-circle-filled {
  cursor: pointer;
}
.ChooseAFlightHeader > .route-info-container .route-info {
  display: flex;
  text-align: center;
  align-items: center;
  margin: auto;
}
.ChooseAFlightHeader > .route-info-container .route-info > p {
  margin-bottom: 0;
}
.ChooseAFlightHeader > .route-info-container .route-info > p.airport {
  font-size: 24px;
  padding-left: 15px;
  padding-right: 15px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.8px;
}
.ChooseAFlightHeader > .route-info-container .route-info > p.suffix {
  font-size: 15px;
  font-weight: normal;
  padding-top: 3px;
}

.ChooseAFlight .plane-meta {
  width: 95%;
  max-width: 968px;
}

.PlaneCarousel {
  width: 95%;
  max-width: 968px;
}

.res-main {
  padding-left: 15px;
  padding-right: 15px;
}
.res-main.top-pad {
  padding-top: 30px !important;
  padding-bottom: 60px !important;
}
.res-main.empty-pad {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

.ruler-mid {
  display: inline-block;
  width: 100%;
  border-top: 1px solid #d5dce7;
}

.header-sec {
  margin-bottom: 20px;
}
.header-sec h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 46px;
  align-items: center;
  color: #000000;
}
.header-sec .lower {
  margin-top: 40px;
}
.header-sec .small-text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 10px;
  color: #2c3034;
  opacity: 0.8;
  display: inline-block;
  padding: 0;
}
.header-sec .small-text span {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  color: #848b94;
  opacity: 0.8;
}
.header-sec .right {
  text-align: right;
}

.pad-0 {
  padding: 0;
}

.peak-style {
  margin-top: -100px;
  margin-bottom: 30px;
  border-radius: 24px;
  background-color: #EF3838;
  padding: 20px 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.peak-style .info-text {
  color: #fff;
  font-size: 15px;
}
.peak-style .peak-headline {
  color: #FFFFFF;
  margin-bottom: 5px;
  font-size: 21px;
  font-weight: 600;
  margin-left: 48px;
}
.peak-style .header {
  display: flex;
  flex-direction: row;
}
.peak-style .header .icon {
  width: 29px;
  height: 26.3px;
  color: #F1F4F9;
  align-self: center;
  margin-top: -25px;
}
.peak-style .header .peak-msg {
  margin-left: 18px;
  color: #FFFFFF;
  margin-bottom: 5px;
  font-size: 14px !important;
  margin-right: 15px;
  margin-top: -1px;
  width: 63%;
}

.peak-mob {
  display: none;
}

.peak-web {
  visibility: visible;
}

.footer-main img {
  width: 100%;
}

@media screen and (max-width: 451px) {
  .ChooseAFlightHeader {
    padding: 16px;
  }
  .ChooseAFlightHeader > .route-info-container {
    width: 100%;
  }
  .ChooseAFlightHeader > h1 {
    width: 100%;
  }
  .show-main-summary {
    visibility: hidden;
    display: none;
  }
  .show-phn-summary {
    display: block !important;
  }
  .ChooseAFlight .disable-amt-container {
    width: 100%;
  }
  .ChooseAFlight .no-flight-msg {
    font-size: 18px;
  }
  .ChooseAFlight .details-container {
    width: 100%;
    flex-wrap: wrap;
  }
  .ChooseAFlight .details-container .info-container {
    width: 95%;
    margin: auto;
  }
  .ChooseAFlight .details-container .amount-containers {
    width: 100%;
    margin-right: 20px;
    margin-left: 4px;
    margin-top: 20px;
  }
  .ChooseAFlight .tripsummary-fixed {
    position: relative;
  }
  .ChooseAFlight .book-flight-summary {
    display: block;
    width: 100%;
  }
  .disabled-aircraft {
    margin-top: 70px;
  }
  .disabled-aircraft .details-container {
    margin: 30px auto 30px !important;
  }
  .peak-mob {
    display: inline !important;
  }
  .peak-web {
    display: none !important;
    visibility: hidden !important;
  }
  .peak-style {
    margin-top: 15px;
  }
  .peak-style .peak-msg {
    width: 100% !important;
  }
  .header-sec h2 {
    font-size: 26px;
  }
}
.PlaneCarousel .image-slide {
  width: 100%;
}

@media screen and (min-width: 451px) and (max-width: 800px) {
  .ChooseAFlightHeader > h1 {
    width: 95%;
  }
  .show-main-summary {
    visibility: hidden;
    display: none;
  }
  .show-phn-summary {
    display: block !important;
  }
  .ChooseAFlightHeader > .route-info-container {
    width: 95%;
  }
  .ChooseAFlight .flight-info {
    display: block !important;
  }
  .ChooseAFlight .jet-img {
    width: 100% !important;
  }
  .ChooseAFlight .jet-desc {
    color: #2c3034;
    margin: 42px auto 0 auto;
    width: 100%;
  }
  .ChooseAFlight .jet-desc .desc-header-left {
    background-position: right;
  }
  .ChooseAFlight .disable-amt-container {
    width: 100%;
  }
  .ChooseAFlight .plane-meta {
    width: 95%;
  }
  .ChooseAFlight .details-container {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    width: 100%;
  }
  .ChooseAFlight .details-container .amount-containers,
  .ChooseAFlight .details-container .info-container {
    width: 95%;
  }
  .ChooseAFlight .details-container .amount-containers {
    margin-left: 4px;
  }
  .ChooseAFlight .book-flight-summary {
    display: block;
    width: 85%;
  }
  .PlaneCarousel {
    width: 100%;
  }
  .PlaneCarousel .image-slide {
    height: 310px;
    width: 100%;
  }
  .ApplicationTab .tab-container {
    width: 95%;
  }
  .book-flight-summary {
    display: block;
    width: 85%;
  }
  .info-container .unavailable {
    width: 95%;
  }
  .peak-mob {
    display: inline;
  }
  .peak-web {
    display: none;
    visibility: hidden;
  }
  .peak-style {
    margin-top: 15px;
  }
  .peak-style .peak-msg {
    width: 75% !important;
  }
}
@media screen and (min-width: 800px) and (max-width: 1200px) {
  .ChooseAFlightHeader > h1 {
    width: 95%;
  }
  .ChooseAFlightHeader > .route-info-container {
    width: 95%;
  }
  .ChooseAFlight .container,
  .ChooseAFlight .container-md,
  .ChooseAFlight .container-sm {
    max-width: 90%;
  }
  .ChooseAFlight .disable-amt-container {
    width: 100%;
  }
  .ChooseAFlight .plane-meta {
    width: 95%;
  }
  .ChooseAFlight .details-container {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    width: 100%;
  }
  .ChooseAFlight .details-container .amount-containers,
  .ChooseAFlight .details-container .info-container {
    width: 95%;
    margin: 3%;
  }
  .ChooseAFlight .book-flight-summary {
    display: flex;
    width: 85%;
  }
  .PlaneCarousel {
    width: 95%;
  }
  .PlaneCarousel .image-slide {
    height: 310px;
    width: 95%;
  }
  .ApplicationTab .tab-container {
    width: 95%;
  }
  .book-flight-summary {
    display: flex;
    width: 85%;
  }
  .peak-style {
    margin-top: -50px;
  }
  .header-sec .small-text {
    line-height: 20px;
  }
}
@media screen and (max-width: 1584px) {
  .ChooseAFlight .flight-info {
    margin: 4% auto 4%;
  }
  nav ul {
    margin-top: 7px;
  }
  .ChooseAFlightHeader {
    padding-bottom: 2px;
    padding-top: 0px;
  }
}
@media screen and (max-width: 575px) {
  .header-sec .right {
    text-align: left !important;
  }
  .default-header {
    padding-bottom: 11px;
  }
  .trip-summary-padding-style {
    padding-right: 18px !important;
    padding-left: 18px !important;
  }
  .header-sec .small-text {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 10px;
    color: #2c3034;
    opacity: 0.8;
    display: inline-block;
    padding: 12px 0px;
  }
  .flex-container {
    flex-direction: column;
  }
  .main-content {
    order: 1;
  }
  .trip-summary {
    order: 2;
  }
  .ChooseAFlight .tripsummary-fixed {
    display: none;
  }
  .ChooseAFlight .details-container .info-container {
    width: 100%;
    margin: auto;
  }
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
}

.main-content {
  order: 1;
}

.trip-summary {
  order: 2;
}

@media screen and (min-width: 575px) {
  .details-container-mob-view {
    display: none;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  .header-sec .small-text {
    line-height: 20px !important;
  }
}
@media screen and (max-width: 768px) and (orientation: landscape) {
  .col-custom {
    width: 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.details-container-view {
  display: none !important;
}

@media screen and (min-width: 576px) and (max-width: 767px) and (orientation: landscape) {
  .header-sec .small-text {
    line-height: 22px;
  }
}
.first-line {
  display: inline;
  white-space: nowrap;
}

@media screen and (min-width: 1200px) {
  .details-container-position {
    margin-top: 6.7rem !important;
  }
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 1407px !important;
  }
}
@media screen and (max-width: 575px) {
  .res-main {
    padding-left: 8px;
    padding-right: 8px;
  }
  .res-main.top-pad {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .res-main .no-flight-msg-margin-mob {
    margin-top: 37px;
    margin-bottom: 27px;
  }
  .res-main .unavailable-box {
    margin-top: 100px;
  }
  .ruler-mid-view {
    display: none;
  }
  .mobile-padding-30 {
    padding-top: 2px;
  }
  .mob-margin-top {
    margin-top: -10px;
  }
  .mob-top-pad {
    margin-top: 6px;
  }
  .mob-row-margin {
    margin-top: -25px;
  }
}
@media screen and (min-width: 1200px) {
  .ChooseAFlightHeader > .route-info-container {
    width: 66%;
    max-width: none;
  }
}
.load-more-button-padding {
  padding-right: 6px;
}

.load-value-font-weight {
  font-weight: 500;
}

@media screen and (max-width: 412px) {
  .header-sec .small-text {
    font-size: 15px;
  }
}
@media screen and (max-width: 768px) {
  .ChooseAFlightHeader > .route-info-container {
    padding: 18px 20px 15px 18px;
  }
  .ChooseAFlightHeader > .route-info-container .route-info > p.airport {
    font-size: 18px;
    padding-left: 18px;
    padding-right: 18px;
  }
  .ChooseAFlightHeader > .route-info-container {
    border-radius: 12px;
  }
  .ChooseAFlightHeader > .route-info-container > .panel-icon-box {
    width: 32px;
    height: 32px;
  }
  .ChooseAFlightHeader > .route-info-container > .panel-icon-box .panel-icon-edit-vector {
    width: 13px;
    height: 13px;
  }
}
@media screen and (min-width: 780px) and (max-width: 830px) {
  .trip-summary-padding-style {
    padding-left: 25px !important;
    padding-right: 32px !important;
  }
}
.aircraft-list-error-message {
  font-size: 22px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 17px;
  line-height: 25px;
  padding-bottom: 15px;
  margin-top: 0px;
  position: relative;
  bottom: 12px;
}

@media screen and (max-width: 767px) {
  .aircraft-list-error-message {
    bottom: 0px;
    line-height: 30px;
    top: 10px;
  }
  .hide-on-small-screens {
    display: none;
  }
  .flight-sub-div {
    position: fixed;
    width: 100%;
    top: 60px;
    z-index: 2;
  }
  .flight-info {
    margin-top: 50px !important;
  }
}
.unavailable-box {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  border-radius: 24px;
  background-color: #848b94;
  padding: 20px;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}

.unavailable-image {
  width: 300px;
  margin-bottom: 20px;
}

.unavailable-message h3 {
  font-size: 35px;
  font-weight: 600;
  color: #fff;
  font-family: "FKGroteskNeue-Medium";
  padding-left: 10px;
}

.info-text {
  color: #fff;
  font-size: 15px;
}

.unvailable-message-header {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.exclamation-icon {
  align-self: center;
  position: relative;
  bottom: 4px;
}

.aircraftlisterror {
  max-width: 447px;
  word-wrap: break-word;
  line-height: 1.5;
}

@media screen and (max-width: 767px) {
  .trip-estimate-top {
    padding-top: 8px;
  }
  .sroll-header {
    background-color: #FFFFFF !important;
    padding-bottom: 0px;
    padding-top: 8px;
  }
  .unavailable-box-container {
    padding-right: 22px !important;
    padding-left: 22px !important;
  }
}
@media screen and (min-width: 767px) {
  .unavailable-box {
    width: 504px;
  }
}
@media screen and (min-width: 768px) and (max-width: 900px) {
  .trip-estimate-top {
    display: none;
  }
}
.default-header {
  background-color: #F4F4F4;
  padding-top: 20px;
}

.sroll-header {
  background-color: #F4F4F4;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .default-header {
    padding-bottom: 20px;
  }
  .sroll-header {
    padding-bottom: 20px;
  }
  .ChooseAFlightHeader > .route-info-container .route-info > p.airport {
    font-size: 23px !important;
  }
}
@media screen and (min-width: 451px) and (max-width: 767px) {
  .ChooseAFlight .jet-desc {
    width: 100% !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 800px) {
  .ChooseAFlight .jet-desc {
    width: 60% !important;
  }
  .ChooseAFlight .jet-desc .desc-header-mid {
    margin: -5px 5px 0 11px !important;
  }
}
@media screen and (min-width: 801px) and (max-width: 1200px) {
  .ChooseAFlight .jet-desc .desc-header-mid {
    margin: -5px 5px 0 11px;
  }
}
@media screen and (min-width: 801px) and (max-width: 1200px) {
  .ChooseAFlight .jet-desc {
    margin: 41px 20px 9px;
    width: 62%;
  }
}
@media screen and (min-width: 891px) and (max-width: 1024px) {
  .res-summary-margin {
    margin-top: 120px;
  }
  .ChooseAFlight .details-container {
    width: 332px !important;
  }
  .TripSummary .trip-body .quote-succ .quote-succ-tick {
    width: 65px !important;
    height: 65px !important;
    padding: 4% 0 !important;
  }
  .TripSummary .trip-body .quote-succ .qoute-succ-img {
    width: 35px;
    height: 35px;
  }
  .TripSummary .trip-body .quote-succ .quote-succ-msg {
    font-size: 27px !important;
  }
}
.page-not-found {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: fit-content;
  height: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/containers/ChooseAFlight/ChooseAFlight.scss","webpack://./src/containers/ChooseAFlight/themevariable.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,iBAAA;EACA,WAAA;AAFF;AAKE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAHJ;AAME;EACE,UAAA;AAJJ;AAOE;EACE,mBAAA;AALJ;AAQE;EACE,aAAA;AANJ;AASE;EACE,gBAAA;AAPJ;AASI;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;AAPN;AAUI;EACE,cAAA;AARN;AAYE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AAVJ;AAaE;EACE,cC5CoB;ED6CpB,wBAAA;EACA,UAAA;EACA,kBAAA;AAXJ;AAaI;EACE,qBAAA;EAKA,aAAA;EACA,WAAA;AAfN;AAkBI;EAGE,cAAA;EACA,WAAA;EACA,UAAA;AAlBN;AAmBM;EACE,6BAAA;AAjBR;AAqBI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;AAnBN;AAsBI;EAGE,cAAA;EACA,YAAA;EACA,UAAA;AAtBN;AAuBM;EACE,6BAAA;AArBR;AAyBI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AAvBN;AA0BI;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,0BAAA;AAxBN;AA0BM;EACE,UAAA;EACA,YAAA;EACA,iCAAA;AAxBR;AA0BQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAxBV;AA8BE;EACE,UAAA;EACA,YAAA;AA5BJ;AA8BE;EAGE,WAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA/BJ;AAkCE;EACE,iBAAA;AAhCJ;AAmCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAjCJ;AAoCE;EACE,YAAA;EACA,eAAA;AAlCJ;AAqCE;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;EACA,oBAAA;EACA,qBAAA;AAnCJ;AAsCE;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AApCJ;AAuCE;EACE,YEhMS;EFiMT,aAAA;EACA,sBAAA;AArCJ;AAwCM;EACE,YAAA;AAtCR;AA0CE;EACE,eAAA;EACA,MAAA;EACA,UAAA;AAxCJ;AA2CE;EAEE,YAAA;EACA,gBEnNS;AFyKb;AA6CI;EACE,0BAAA;EACA,gBAAA;AA3CN;AA8CI;EAGE,cAAA;AA9CN;AAgDM;EACE,mBAAA;EACA,mBAAA;EACA,yBExNA;EFyNA,kBAAA;AA9CR;AAgDQ;EACE,WEpOF;EFqOE,eAAA;AA9CV;AAiDQ;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AA/CV;AAiDU;EACE,kBAAA;AA/CZ;AAkDU;EACE,0BAAA;EACA,gBAAA;EACA,WEpPJ;EFqPI,gBAAA;EACA,kBAAA;EACA,mCEvOE;AFuLd;AAqDM;EACE,mBAAA;AAnDR;AAuDI;EACE,kBAAA;AArDN;AAyDE;EACE,UAAA;EACA,gBE3QS;AFoNb;AA2DI;EACE,WAAA;AAzDN;AA4DI;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AA1DN;AA6DI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AA3DN;AA8DI;EACE,cErRE;EFsRF,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AA5DN;AA+DI;EACE,cE9RE;EF+RF,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AA7DN;AAiEE;EAEE,kBAAA;AAhEJ;;AAoEA;EAEE,WEvTM;EFyTN,oBAAA;AAnEF;AA+EE;EACE,UAAA;EACA,gBE1US;EF2UT,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA7EJ;AAgFE;EACE,UAAA;EACA,gBEpVS;EFqVT,YAAA;EACA,yBCpVkB;EDqVlB,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AA9EJ;AAgFI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9EN;AAgFM;EACE,sBAAA;EACA,uBAAA;AA9ER;AA+EQ;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AA7EV;AAgFM;EACE,sBAAA;EACA,uBAAA;AA9ER;AA+EQ;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AA7EV;AAkFI;EACE,eAAA;AAhFN;AAmFI;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAjFN;AAmFM;EACE,gBAAA;AAjFR;AAmFQ;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAjFV;AAoFQ;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AAlFV;;AA0FE;EACE,UAAA;EACA,gBE7ZS;AFsUb;;AA2FA;EACE,UAAA;EACA,gBEnaW;AF2Ub;;AA2FA;EACE,kBAAA;EACA,mBAAA;AAxFF;AA0FE;EACE,4BAAA;EACA,+BAAA;AAxFJ;AA0FE;EACE,4BAAA;EACA,+BAAA;AAxFJ;;AA4FA;EACE,qBAAA;EACA,WAAA;EACA,6BAAA;AAzFF;;AA4FA;EACE,mBAAA;AAzFF;AA2FE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAzFJ;AA4FE;EACE,gBAAA;AA1FJ;AA6FE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;AA3FJ;AA6FI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AA3FN;AA+FE;EACE,iBAAA;AA7FJ;;AAiGA;EACE,UAAA;AA9FF;;AAiGA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBEncU;EFocV,kBAAA;EACA,iBAAA;EACA,oBAAA;AA9FF;AAgGE;EACE,WE/eI;EFgfJ,eAAA;AA9FJ;AAiGE;EAEE,cCxfsB;EDyftB,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAhGJ;AAmGE;EACE,aAAA;EACA,mBAAA;AAjGJ;AAmGI;EACE,WAAA;EACA,cAAA;EACA,cEveS;EFweT,kBAAA;EACA,iBAAA;AAjGN;AAoGI;EACE,iBAAA;EACA,cC1gBa;ED2gBb,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAlGN;;AAuGA;EACE,aAAA;AApGF;;AAuGA;EACE,mBAAA;AApGF;;AAuGA;EACE,WAAA;AApGF;;AAuGA;EACE;IASE,aAAA;EA5GF;EAoGE;IACE,WAAA;EAlGJ;EAqGE;IACE,WAAA;EAnGJ;EAyGA;IACE,kBAAA;IACA,aAAA;EAvGF;EA0GA;IACE,yBAAA;EAxGF;EA4GE;IACE,WAAA;EA1GJ;EA4GE;IACE,eAAA;EA1GJ;EA4GE;IACE,WAAA;IACA,eAAA;EA1GJ;EA4GI;IACE,UAAA;IACA,YAAA;EA1GN;EA6GI;IACE,WAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;EA3GN;EA8GE;IACE,kBAAA;EA5GJ;EA+GE;IACE,cAAA;IACA,WAAA;EA7GJ;EAiHA;IACE,gBAAA;EA/GF;EAiHE;IACE,iCAAA;EA/GJ;EAmHA;IACE,0BAAA;EAjHF;EAoHA;IACE,wBAAA;IACA,6BAAA;EAlHF;EAqHA;IACE,gBAAA;EAnHF;EAqHE;IACE,sBAAA;EAnHJ;EAsHA;IACE,eAAA;EApHF;AACF;AAwHE;EACE,WAAA;AAtHJ;;AA0HA;EACE;IACE,UAAA;EAvHF;EA0HA;IACE,kBAAA;IACA,aAAA;EAxHF;EA2HA;IACE,yBAAA;EAzHF;EA4HA;IACE,UAAA;EA1HF;EA8HE;IACE,yBAAA;EA5HJ;EA8HE;IACE,sBAAA;EA5HJ;EA8HE;IACE,cAAA;IACA,wBAAA;IACA,WAAA;EA5HJ;EAiII;IACE,0BAAA;EA/HN;EAmIE;IACE,WAAA;EAjIJ;EAoIE;IACE,UAAA;EAlIJ;EAqIE;IACE,eAAA;IACA,8BAAA;IACA,WAAA;EAnIJ;EAsII;;IAEE,UAAA;EApIN;EAwII;IACE,gBAAA;EAtIN;EA0IE;IACE,cAAA;IACA,UAAA;EAxIJ;EA4IA;IACE,WAAA;EA1IF;EA4IE;IACE,aAAA;IACA,WAAA;EA1IJ;EA8IA;IACE,UAAA;EA5IF;EA+IA;IACE,cAAA;IACA,UAAA;EA7IF;EAiJE;IACE,UAAA;EA/IJ;EAmJA;IACE,eAAA;EAjJF;EAoJA;IACE,aAAA;IACA,kBAAA;EAlJF;EAqJA;IACE,gBAAA;EAnJF;EAqJE;IACE,qBAAA;EAnJJ;AACF;AAuJA;EACE;IACE,UAAA;EArJF;EAwJA;IACE,UAAA;EAtJF;EA0JE;;;IAGE,cAAA;EAxJJ;EA0JE;IACE,WAAA;EAxJJ;EA2JE;IACE,UAAA;EAzJJ;EA4JE;IACE,eAAA;IACA,8BAAA;IACA,WAAA;EA1JJ;EA4JI;;IAEE,UAAA;IACA,UAAA;EA1JN;EA8JE;IACE,aAAA;IACA,UAAA;EA5JJ;EAgKA;IACE,UAAA;EA9JF;EAgKE;IACE,aAAA;IACA,UAAA;EA9JJ;EAkKA;IACE,UAAA;EAhKF;EAmKA;IACE,aAAA;IACA,UAAA;EAjKF;EAoKA;IACE,iBAAA;EAlKF;EAoKA;IACE,iBAAA;EAlKF;AACF;AAoKA;EACE;IACE,kBAAA;EAlKF;EAoKA;IACE,eAAA;EAlKF;EAoKA;IACE,mBAAA;IACA,gBAAA;EAlKF;AACF;AAqKA;EACE;IACE,2BAAA;EAnKF;EAqKA;IACE,oBAAA;EAnKF;EAqKA;IACE,8BAAA;IACA,6BAAA;EAnKF;EAqKA;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;IACA,YAAA;IACA,qBAAA;IACA,iBAAA;EAnKF;EAqKA;IACE,sBAAA;EAnKF;EAsKA;IACE,QAAA;EApKF;EAuKA;IACE,QAAA;EArKF;EAuKA;IACE,aAAA;EArKF;EAuKA;IACE,WAAA;IACA,YAAA;EArKF;AACF;AAwKA;EACE,aAAA;EACA,eAAA;AAtKF;;AAyKA;EACE,QAAA;AAtKF;;AAyKA;EACE,QAAA;AAtKF;;AAwKA;EACE;IACE,aAAA;EArKF;AACF;AAuKA;EACE;IACE,4BAAA;EArKF;AACF;AAwKA;EACE;IACE,WAAA;IACA,cAAA;IACA,eAAA;EAtKF;AACF;AAwKA;EACE,wBAAA;AAtKF;;AAwKA;EACE;IACE,iBAAA;EArKF;AACF;AAuKA;EACE,eAAA;EACA,mBAAA;AArKF;;AAuKA;EACE;IACE,6BAAA;EApKF;EAsKA;;;;;IAKE,4BAAA;EApKF;AACF;AAsKA;EACE;IACE,iBAAA;IACA,kBAAA;EApKF;EAsKE;IACE,2BAAA;IACA,8BAAA;EApKJ;EAsKE;IACE,gBAAA;IACA,mBAAA;EApKJ;EAsKE;IACE,iBAAA;EApKJ;EAuKA;IACE,aAAA;EArKF;EAuKA;IACE,gBAAA;EArKF;EAuKA;IACE,iBAAA;EArKF;EAuKA;IACE,eAAA;EArKF;EAuKA;IACE,iBAAA;EArKF;AACF;AAuKA;EACE;IACE,UAAA;IACA,eAAA;EArKF;AACF;AAuKA;EACE,kBAAA;AArKF;;AAuKA;EACE,gBAAA;AApKF;;AAsKA;EACE;IACE,eAAA;EAnKF;AACF;AAqKA;EACE;IACE,4BAAA;EAnKF;EAqKA;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;EAnKF;EAqKA;IACE,mBAAA;EAnKF;EAqKA;IACE,WAAA;IACA,YAAA;EAnKF;EAqKA;IAIE,WAAA;IACA,YAAA;EAtKF;AACF;AAwKA;EACE;IACE,6BAAA;IACA,8BAAA;EAtKF;AACF;AAwKA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAtKF;;AAwKA;EACE;IACE,WAAA;IACA,iBAAA;IACA,SAAA;EArKF;EAuKA;IACE,aAAA;EArKF;EAuKA;IACE,eAAA;IACA,WAAA;IACA,SAAA;IACA,UAAA;EArKF;EAwKA;IACE,2BAAA;EAtKF;AACF;AA0KA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EAGA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA1KF;;AA8KA;EACE,YAAA;EACA,mBAAA;AA3KF;;AA8KA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AA3KF;;AA6KA;EACE,WAAA;EACA,eAAA;AA1KF;;AA4KA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAzKF;;AA2KA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AAxKF;;AA2KA;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;AAxKF;;AA2KA;EACE;IAEE,gBAAA;EAzKF;EA2KA;IACE,oCAAA;IACA,mBAAA;IACA,gBAAA;EAzKF;EA2KA;IACE,8BAAA;IACA,6BAAA;EAzKF;AACF;AA2KA;EACE;IACE,YAAA;EAzKF;AACF;AA2KA;EACE;IACE,aAAA;EAzKF;AACF;AA2KA;EACE,yBCnlC4B;EDolC5B,iBAAA;AAzKF;;AA2KA;EACE,yBCvlC4B;AD+6B9B;;AA0KA;EACE;IACE,oBAAA;EAvKF;EAyKA;IACE,oBAAA;EAvKF;EAyKA;IACE,0BAAA;EAvKF;AACF;AAyKA;EACE;IACE,sBAAA;EAvKF;AACF;AAyKA;EACE;IACE,qBAAA;EAvKF;EAyKA;IACE,kCAAA;EAvKF;AACF;AAyKA;EACE;IACE,uBAAA;EAvKF;AACF;AAyKA;EACE;IACE,qBAAA;IACA,UAAA;EAvKF;AACF;AAyKA;EACE;IACE,iBAAA;EAvKF;EAyKA;IACE,uBAAA;EAvKF;EAyKA;IACE,sBAAA;IACA,uBAAA;IACA,wBAAA;EAvKF;EAyKA;IACE,WAAA;IACA,YAAA;EAvKF;EAyKA;IACE,0BAAA;EAvKF;AACF;AAyKA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAvKF","sourcesContent":["@use \"src/styles/variables\" as var;\n@use \"src/containers/ChooseAFlight/themevariable\" as theme;\n\n.ChooseAFlight {\n  min-height: 600px;\n  width: 100%;\n\n  // max-width: $page-width;\n  .planeCarousel {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .disable-amt-container {\n    width: 40%;\n  }\n\n  .show-main-summary {\n    visibility: visible;\n  }\n\n  .show-phn-summary {\n    display: none;\n  }\n\n  .disabled-aircraft {\n    margin-top: 70px;\n\n    .details-container {\n      display: flex;\n      width: 100%;\n      max-width: 968px;\n      margin: -15px auto 30px;\n    }\n\n    .info-container {\n      margin: 0 auto;\n    }\n  }\n\n  .flight-info {\n    width: 100%;\n    max-width: 1080px;\n    margin: 2% auto 4%;\n    display: flex;\n  }\n\n  .jet-desc {\n    color: theme.$descriptionFontColor;\n    margin: 42px auto 0 auto;\n    width: 35%;\n    text-align: center;\n\n    .desc-header {\n      display: inline-block;\n      // position: relative;\n      // display: block;\n      // width: 90%;\n      //\\\\ margin: auto;\n      padding: 0 1%;\n      width: 100%;\n    }\n\n    .desc-header-left {\n      // background: url(\"../../assets/custom-theme/Vector30.png\") no-repeat;\n      // width: 30%;\n      height: 7.76px;\n      float: left;\n      width: 31%;\n      img {\n        width: -webkit-fill-available;\n      }\n    }\n\n    .desc-header-mid {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 24px;\n      margin: -5px 5px 0 5px;\n      float: left;\n      width: 33%;\n    }\n\n    .desc-header-right {\n      // background: url(\"../../assets/custom-theme/Vector31.png\") no-repeat;\n      // width: 30%;\n      height: 7.76px;\n      float: right;\n      width: 31%;\n      img {\n        width: -webkit-fill-available;\n      }\n    }\n\n    .desc-body {\n      text-align: center;\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      padding: 20px 12px 12px 12px;\n    }\n\n    .desc-feat {\n      position: relative;\n      display: flex;\n      margin-top: 25px;\n      padding: 0px 70px 0px 70px;\n\n      .f-icons {\n        width: 50%;\n        height: 22px;\n        filter: invert(0%) brightness(0%);\n\n        span {\n          font-style: normal;\n          font-weight: 400;\n          font-size: 16px;\n          line-height: 24px;\n          margin-left: 10px;\n        }\n      }\n    }\n  }\n\n  .jet-img {\n    width: 70%;\n    margin: auto;\n  }\n  .jet-img img {\n    // width: -webkit-fill-available;\n    // height: 220px;\n    width: 100%;\n  }\n\n  .load_btn {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  }\n\n  .ld_mr {\n    margin: 25px auto;\n  }\n\n  .load_btn {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  }\n\n  .no-flight-msg {\n    margin: auto;\n    font-size: 22px;\n  }\n\n  button.loadMore {\n    display: flex;\n    justify-content: center;\n    padding: 8px;\n    border-radius: 70px;\n    height: 42px;\n    background-color: #ffffff;\n    border: 1px solid #3881ef;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 23px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: #694779;\n    padding: 14px 30px;\n    height: 64px;\n    background: #ffffff;\n    border: 1px solid #694779;\n    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.15);\n    border-radius: 140px;\n    letter-spacing: 0.4px;\n  }\n\n  .general-btn {\n    border: 0;\n    border-radius: 30px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-weight: 500;\n  }\n\n  .plane-meta {\n    width: var.$page-width;\n    display: flex;\n    margin: 10px auto auto;\n\n    button {\n      &.blue-btn {\n        float: right;\n      }\n    }\n  }\n  .tripsummary-fixed {\n    position: fixed;\n    top: 0;\n    z-index: 2;\n  }\n\n  .details-container {\n    // display: flex;\n    width: 350px;\n    max-width: var.$page-width;\n    // margin: 10px 0px;\n\n    .title-contact {\n      font-size: 35px !important;\n      font-weight: 600;\n    }\n\n    .info-container {\n      // width: 70%;\n      // margin-right: 25px;\n      margin: 0 auto;\n\n      .unavailable {\n        margin-bottom: 30px;\n        border-radius: 24px;\n        background-color: var.$grey3;\n        padding: 20px 20px;\n\n        .info-text {\n          color: var.$white;\n          font-size: 15px;\n        }\n\n        .header {\n          margin-bottom: 10px;\n          display: flex;\n          flex-direction: row;\n\n          .icon {\n            align-self: center;\n          }\n\n          .title {\n            font-size: 35px !important;\n            font-weight: 600;\n            color: var.$white;\n            margin-bottom: 0;\n            padding-left: 10px;\n            font-family: var.$font-medium;\n          }\n        }\n      }\n\n      .info-text {\n        font-weight: normal;\n      }\n    }\n\n    .amount-containers {\n      margin-left: 133px;\n    }\n  }\n\n  .ApplicationTab .tab-container {\n    width: 95%;\n    max-width: var.$page-width;\n  }\n\n  .good-deal-modal {\n    > img {\n      width: 100%;\n    }\n\n    > .plane-type {\n      text-align: center;\n      font-size: 25px;\n      font-weight: bold;\n    }\n\n    > button {\n      display: flex;\n      align-items: center;\n      margin: 30px auto auto;\n    }\n\n    > .info-text {\n      color: var.$grey3;\n      width: 70%;\n      text-align: center;\n      margin: auto;\n      padding-top: 30px;\n      padding-bottom: 50px;\n    }\n\n    > .info-text-recommended {\n      color: var.$grey3;\n      width: 85%;\n      text-align: center;\n      margin: auto;\n      padding-top: 30px;\n      padding-bottom: 50px;\n    }\n  }\n\n  .Modal .modal-content {\n    // border-radius: 0 !important;\n    border-radius: 8px;\n  }\n}\n\n.ChooseAFlightHeader {\n  // background-color: #f4f4f4;\n  color: var.$white;\n  // padding-top: 20px;\n  padding-bottom: 48px;\n  // padding-right: 15px;\n\n  // > h1 {\n  //   width: $page-width;\n  //   margin: auto;\n  //   font-size: 60px;\n  //   font-weight: 600;\n  //   line-height: 10px;\n  //   padding-bottom: 43px;\n  // }\n\n  > .head-title {\n    width: 95%;\n    max-width: var.$page-width;\n    margin: auto;\n    margin-bottom: auto;\n    margin-bottom: 43px;\n    font-size: 72px;\n    line-height: 80px;\n  }\n\n  > .route-info-container {\n    width: 95%;\n    max-width: var.$page-width;\n    margin: auto;\n    background-color: theme.$customPrimaryColor;\n    padding: 20px;\n    border-radius: 24px;\n    display: flex;\n    cursor: pointer;\n\n    > .panel-icon-box {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      overflow: hidden;\n      background: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      // filter: invert(0%) brightness(0%);\n      > .panel-icon-flight-vector {\n        width: 18px !important;\n        height: 16px !important;\n        > img {\n          display: block;\n          width: 100%;\n          object-fit: cover;\n        }\n      }\n      .panel-icon-edit-vector {\n        width: 16px !important;\n        height: 16px !important;\n        > img {\n          display: block;\n          width: 100%;\n          object-fit: cover;\n        }\n      }\n    }\n\n    .grey-edit-circle-filled {\n      cursor: pointer;\n    }\n\n    .route-info {\n      display: flex;\n      text-align: center;\n      align-items: center;\n      margin: auto;\n\n      > p {\n        margin-bottom: 0;\n\n        &.airport {\n          font-size: 24px;\n          padding-left: 15px;\n          padding-right: 15px;\n          font-weight: 500;\n          font-style: normal;\n          letter-spacing: 0.8px;\n        }\n\n        &.suffix {\n          font-size: 15px;\n          font-weight: normal;\n          padding-top: 3px;\n        }\n      }\n    }\n  }\n}\n\n.ChooseAFlight {\n  .plane-meta {\n    width: 95%;\n    max-width: var.$page-width;\n  }\n}\n\n.PlaneCarousel {\n  width: 95%;\n  max-width: var.$page-width;\n}\n\n.res-main {\n  padding-left: 15px;\n  padding-right: 15px;\n\n  &.top-pad {\n    padding-top: 30px !important;\n    padding-bottom: 60px !important;\n  }\n  &.empty-pad {\n    padding-top: 15px !important;\n    padding-bottom: 15px !important;\n  }\n}\n\n.ruler-mid {\n  display: inline-block;\n  width: 100%;\n  border-top: 1px solid #d5dce7;\n}\n\n.header-sec {\n  margin-bottom: 20px;\n\n  h2 {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 36px;\n    line-height: 46px;\n    align-items: center;\n    color: #000000;\n  }\n\n  .lower {\n    margin-top: 40px;\n  }\n\n  .small-text {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 10px;\n    color: #2c3034;\n    opacity: 0.8;\n    display: inline-block;\n    padding: 0;\n\n    span {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      text-align: right;\n      color: #848b94;\n      opacity: 0.8;\n    }\n  }\n\n  .right {\n    text-align: right;\n  }\n}\n\n.pad-0 {\n  padding: 0;\n}\n\n.peak-style {\n  margin-top: -100px;\n  margin-bottom: 30px;\n  border-radius: 24px;\n  background-color: var.$error-red;\n  padding: 20px 20px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n\n  .info-text {\n    color: var.$white;\n    font-size: 15px;\n  }\n\n  .peak-headline {\n    // text-align: center;\n    color: theme.$defaultBackgroundColor;\n    margin-bottom: 5px;\n    font-size: 21px;\n    font-weight: 600;\n    margin-left: 48px;\n  }\n\n  .header {\n    display: flex;\n    flex-direction: row;\n\n    .icon {\n      width: 29px;\n      height: 26.3px;\n      color: var.$primary-gray;\n      align-self: center;\n      margin-top: -25px;\n    }\n\n    .peak-msg {\n      margin-left: 18px;\n      color: theme.$customFontColor;\n      margin-bottom: 5px;\n      font-size: 14px !important;\n      margin-right: 15px;\n      margin-top: -1px;\n      width: 63%;\n    }\n  }\n}\n\n.peak-mob {\n  display: none;\n}\n\n.peak-web {\n  visibility: visible;\n}\n\n.footer-main img {\n  width: 100%;\n}\n\n@media screen and (var.$mobile-media) {\n  .ChooseAFlightHeader {\n    > .route-info-container {\n      width: 100%;\n    }\n\n    > h1 {\n      width: 100%;\n    }\n\n    padding: 16px;\n  }\n\n  .show-main-summary {\n    visibility: hidden;\n    display: none;\n  }\n\n  .show-phn-summary {\n    display: block !important;\n  }\n\n  .ChooseAFlight {\n    .disable-amt-container {\n      width: 100%;\n    }\n    .no-flight-msg {\n      font-size: 18px;\n    }\n    .details-container {\n      width: 100%;\n      flex-wrap: wrap;\n\n      .info-container {\n        width: 95%;\n        margin: auto;\n      }\n\n      .amount-containers {\n        width: 100%;\n        margin-right: 20px;\n        margin-left: 4px;\n        margin-top: 20px;\n      }\n    }\n    .tripsummary-fixed {\n      position: relative;\n    }\n\n    .book-flight-summary {\n      display: block;\n      width: 100%;\n    }\n  }\n\n  .disabled-aircraft {\n    margin-top: 70px;\n\n    .details-container {\n      margin: 30px auto 30px !important;\n    }\n  }\n\n  .peak-mob {\n    display: inline !important;\n  }\n\n  .peak-web {\n    display: none !important;\n    visibility: hidden !important;\n  }\n\n  .peak-style {\n    margin-top: 15px;\n\n    .peak-msg {\n      width: 100% !important;\n    }\n  }\n  .header-sec h2 {\n    font-size: 26px;\n  }\n}\n\n.PlaneCarousel {\n  .image-slide {\n    width: 100%;\n  }\n}\n\n@media screen and (var.$tablet-media-min) and (var.$tablet-media) {\n  .ChooseAFlightHeader > h1 {\n    width: 95%;\n  }\n\n  .show-main-summary {\n    visibility: hidden;\n    display: none;\n  }\n\n  .show-phn-summary {\n    display: block !important;\n  }\n\n  .ChooseAFlightHeader > .route-info-container {\n    width: 95%;\n  }\n\n  .ChooseAFlight {\n    .flight-info {\n      display: block !important;\n    }\n    .jet-img {\n      width: 100% !important;\n    }\n    .jet-desc {\n      color: #2c3034;\n      margin: 42px auto 0 auto;\n      width: 100%;\n      .desc-header {\n        // width: 50%;\n      }\n\n      .desc-header-left {\n        background-position: right;\n      }\n    }\n\n    .disable-amt-container {\n      width: 100%;\n    }\n\n    .plane-meta {\n      width: 95%;\n    }\n\n    .details-container {\n      flex-wrap: wrap;\n      flex-direction: column-reverse;\n      width: 100%;\n      // margin-left: 2%;\n\n      .amount-containers,\n      .info-container {\n        width: 95%;\n        // margin: 3%;\n      }\n\n      .amount-containers {\n        margin-left: 4px;\n      }\n    }\n\n    .book-flight-summary {\n      display: block;\n      width: 85%;\n    }\n  }\n\n  .PlaneCarousel {\n    width: 100%;\n\n    .image-slide {\n      height: 310px;\n      width: 100%;\n    }\n  }\n\n  .ApplicationTab .tab-container {\n    width: 95%;\n  }\n\n  .book-flight-summary {\n    display: block;\n    width: 85%;\n  }\n\n  .info-container {\n    .unavailable {\n      width: 95%;\n    }\n  }\n\n  .peak-mob {\n    display: inline;\n  }\n\n  .peak-web {\n    display: none;\n    visibility: hidden;\n  }\n\n  .peak-style {\n    margin-top: 15px;\n\n    .peak-msg {\n      width: 75% !important;\n    }\n  }\n}\n\n@media screen and (var.$tablet-media-min-hz) and (var.$tablet-media-hz) {\n  .ChooseAFlightHeader > h1 {\n    width: 95%;\n  }\n\n  .ChooseAFlightHeader > .route-info-container {\n    width: 95%;\n  }\n\n  .ChooseAFlight {\n    .container,\n    .container-md,\n    .container-sm {\n      max-width: 90%;\n    }\n    .disable-amt-container {\n      width: 100%;\n    }\n\n    .plane-meta {\n      width: 95%;\n    }\n\n    .details-container {\n      flex-wrap: wrap;\n      flex-direction: column-reverse;\n      width: 100%;\n\n      .amount-containers,\n      .info-container {\n        width: 95%;\n        margin: 3%;\n      }\n    }\n\n    .book-flight-summary {\n      display: flex;\n      width: 85%;\n    }\n  }\n\n  .PlaneCarousel {\n    width: 95%;\n\n    .image-slide {\n      height: 310px;\n      width: 95%;\n    }\n  }\n\n  .ApplicationTab .tab-container {\n    width: 95%;\n  }\n\n  .book-flight-summary {\n    display: flex;\n    width: 85%;\n  }\n\n  .peak-style {\n    margin-top: -50px;\n  }\n  .header-sec .small-text {\n    line-height: 20px;\n  }\n}\n@media screen and (max-width: 1584px) {\n  .ChooseAFlight .flight-info {\n    margin: 4% auto 4%;\n  }\n  nav ul {\n    margin-top: 7px;\n  }\n  .ChooseAFlightHeader {\n    padding-bottom: 2px;\n    padding-top: 0px;\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .header-sec .right {\n    text-align: left !important;\n  }\n  .default-header {\n    padding-bottom: 11px;\n  }\n  .trip-summary-padding-style {\n    padding-right: 18px !important;\n    padding-left: 18px !important;\n  }\n  .header-sec .small-text {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 10px;\n    color: #2c3034;\n    opacity: 0.8;\n    display: inline-block;\n    padding: 12px 0px;\n  }\n  .flex-container {\n    flex-direction: column;\n  }\n\n  .main-content {\n    order: 1;\n  }\n\n  .trip-summary {\n    order: 2;\n  }\n  .ChooseAFlight .tripsummary-fixed {\n    display: none;\n  }\n  .ChooseAFlight .details-container .info-container {\n    width: 100%;\n    margin: auto;\n  }\n}\n\n.flex-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.main-content {\n  order: 1;\n}\n\n.trip-summary {\n  order: 2;\n}\n@media screen and (min-width: 575px) {\n  .details-container-mob-view {\n    display: none;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 1200px) {\n  .header-sec .small-text {\n    line-height: 20px !important;\n  }\n}\n\n@media screen and (max-width: 768px) and (orientation: landscape) {\n  .col-custom {\n    width: 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n.details-container-view {\n  display: none !important;\n}\n@media screen and (min-width: 576px) and (max-width: 767px) and (orientation: landscape) {\n  .header-sec .small-text {\n    line-height: 22px;\n  }\n}\n.first-line {\n  display: inline;\n  white-space: nowrap;\n}\n@media screen and (min-width: 1200px) {\n  .details-container-position {\n    margin-top: 6.7rem !important;\n  }\n  .container,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container-xl {\n    max-width: 1407px !important;\n  }\n}\n@media screen and (max-width: 575px) {\n  .res-main {\n    padding-left: 8px;\n    padding-right: 8px;\n\n    &.top-pad {\n      padding-top: 0px !important;\n      padding-bottom: 0px !important;\n    }\n    .no-flight-msg-margin-mob {\n      margin-top: 37px;\n      margin-bottom: 27px;\n    }\n    .unavailable-box {\n      margin-top: 100px;\n    }\n  }\n  .ruler-mid-view {\n    display: none;\n  }\n  .mobile-padding-30 {\n    padding-top: 2px;\n  }\n  .mob-margin-top {\n    margin-top: -10px;\n  }\n  .mob-top-pad {\n    margin-top: 6px;\n  }\n  .mob-row-margin {\n    margin-top: -25px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .ChooseAFlightHeader > .route-info-container {\n    width: 66%;\n    max-width: none;\n  }\n}\n.load-more-button-padding {\n  padding-right: 6px;\n}\n.load-value-font-weight {\n  font-weight: 500;\n}\n@media screen and (max-width: 412px) {\n  .header-sec .small-text {\n    font-size: 15px;\n  }\n}\n@media screen and (max-width: 768px) {\n  .ChooseAFlightHeader > .route-info-container {\n    padding: 18px 20px 15px 18px;\n  }\n  .ChooseAFlightHeader > .route-info-container .route-info > p.airport {\n    font-size: 18px;\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n  .ChooseAFlightHeader > .route-info-container {\n    border-radius: 12px;\n  }\n  .ChooseAFlightHeader > .route-info-container > .panel-icon-box {\n    width: 32px;\n    height: 32px;\n  }\n  .ChooseAFlightHeader\n    > .route-info-container\n    > .panel-icon-box\n    .panel-icon-edit-vector {\n    width: 13px;\n    height: 13px;\n  }\n}\n@media screen and (min-width: 780px) and (max-width: 830px) {\n  .trip-summary-padding-style {\n    padding-left: 25px !important;\n    padding-right: 32px !important;\n  }\n}\n.aircraft-list-error-message {\n  font-size: 22px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-left: 17px;\n  line-height: 25px;\n  padding-bottom: 15px;\n  margin-top: 0px;\n  position: relative;\n  bottom: 12px;\n}\n@media screen and (max-width: 767px) {\n  .aircraft-list-error-message {\n    bottom: 0px;\n    line-height: 30px;\n    top: 10px;\n  }\n  .hide-on-small-screens {\n    display: none;\n  }\n  .flight-sub-div {\n    position: fixed;\n    width: 100%;\n    top: 60px;\n    z-index: 2;\n  }\n\n  .flight-info {\n    margin-top: 50px !important;\n  }\n}\n\n//unavialbale box style\n.unavailable-box {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 30px;\n  border-radius: 24px;\n  background-color: #848b94;\n  padding: 20px;\n  // position: relative;\n  // left:450px;\n  justify-content: center;\n  align-items: center;\n  margin-left: auto;\n  margin-right: auto;\n  // min-height: 100vh;\n}\n\n.unavailable-image {\n  width: 300px;\n  margin-bottom: 20px;\n}\n\n.unavailable-message h3 {\n  font-size: 35px;\n  font-weight: 600;\n  color: #fff;\n  font-family: \"FKGroteskNeue-Medium\";\n  padding-left: 10px;\n}\n.info-text {\n  color: #fff;\n  font-size: 15px;\n}\n.unvailable-message-header {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n}\n.exclamation-icon {\n  align-self: center;\n  position: relative;\n  bottom: 4px;\n}\n\n.aircraftlisterror {\n  max-width: 447px;\n  word-wrap: break-word;\n  line-height: 1.5;\n}\n//app tab gap for small screen\n@media screen and (max-width: 767px) {\n  .trip-estimate-top {\n    // background-color: $searchPanelBackgroundColor;\n    padding-top: 8px;\n  }\n  .sroll-header {\n    background-color: theme.$defaultBackgroundColor !important;\n    padding-bottom: 0px;\n    padding-top: 8px;\n  }\n  .unavailable-box-container {\n    padding-right: 22px !important;\n    padding-left: 22px !important;\n  }\n}\n@media screen and (min-width: 767px) {\n  .unavailable-box {\n    width: 504px;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 900px) {\n  .trip-estimate-top {\n    display: none;\n  }\n}\n.default-header {\n  background-color: theme.$searchPanelBackgroundColor;\n  padding-top: 20px;\n}\n.sroll-header {\n  background-color: theme.$searchPanelBackgroundColor;\n}\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .default-header {\n    padding-bottom: 20px;\n  }\n  .sroll-header {\n    padding-bottom: 20px;\n  }\n  .ChooseAFlightHeader > .route-info-container .route-info > p.airport {\n    font-size: 23px !important;\n  }\n}\n@media screen and (min-width: 451px) and (max-width: 767px) {\n  .ChooseAFlight .jet-desc {\n    width: 100% !important;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 800px) {\n  .ChooseAFlight .jet-desc {\n    width: 60% !important;\n  }\n  .ChooseAFlight .jet-desc .desc-header-mid {\n    margin: -5px 5px 0 11px !important;\n  }\n}\n@media screen and (min-width: 801px) and (max-width: 1200px) {\n  .ChooseAFlight .jet-desc .desc-header-mid {\n    margin: -5px 5px 0 11px;\n  }\n}\n@media screen and (min-width: 801px) and (max-width: 1200px) {\n  .ChooseAFlight .jet-desc {\n    margin: 41px 20px 9px;\n    width: 62%;\n  }\n}\n@media screen and (min-width: 891px) and (max-width: 1024px) {\n  .res-summary-margin {\n    margin-top: 120px;\n  }\n  .ChooseAFlight .details-container {\n    width: 332px !important;\n  }\n  .TripSummary .trip-body .quote-succ .quote-succ-tick {\n    width: 65px !important;\n    height: 65px !important;\n    padding: 4% 0 !important;\n  }\n  .TripSummary .trip-body .quote-succ .qoute-succ-img {\n    width: 35px;\n    height: 35px;\n  }\n  .TripSummary .trip-body .quote-succ .quote-succ-msg {\n    font-size: 27px !important;\n  }\n}\n.page-not-found {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  width: fit-content;\n  height: fit-content;\n}\n","$defaultBackgroundColor : #FFFFFF;\n$defaultFontColor : #000000;\n$customPrimaryColor : #694779;\n$customFontColor : #FFFFFF;\n$searchPanelBackgroundColor : #F4F4F4;\n$descriptionFontColor : #2C3034;\n$customSecondaryColor : #F1F4F9;\n$listItemFeatureFontColor : #535A61;\n$conciergeButtonBackgroundColor : #B9A691;","$page-width: 968px;\n$page-short-width: 700px;\n$black: #000;\n$white: #fff;\n$yellow: #ebff0c;\n$blue: #3881ef;\n$blue1:#4782E7;\n$red: #ef3838;\n$dark-blue: #1d6add;\n$grey1: #f1f4f9;\n$grey2: #cfcdcd;\n$grey3: #848b94;\n$grey4: #d5dce7;\n$grey5: #2c3034;\n$grey6: #535a61;\n$grey7: #9ca2a9;\n$grey8: #666d74;\n\n$font-regular: 'FKGroteskNeue-Regular';\n$font-medium: 'FKGroteskNeue-Medium';\n$font-bold: 'FKGroteskNeue-Bold';\n$mobile-media: 'max-width: 451px';\n$tablet-media-min: 'min-width: 451px';\n$tablet-media: 'max-width: 800px';\n$tablet-media-min-hz: 'min-width: 800px';\n$tablet-media-hz: 'max-width: 1200px';\n\n// Guide Color Code ----------------------------------\n\n$primary-black: #000000;\n$primary-white: #FFFFFF;\n$primary-gray: #F1F4F9;\n$secondary-yellow: #EBFF0C;\n$secondary-skyblue: #3881EF;\n$secondary-darkblue: #1D6ADD;\n$light-gray1: #F1F4F9;\n$light-gray2: #D5DCE7;\n$light-gray3: #848B94;\n$dark-gray1: #2C3034;\n$dark-gray2: #535A61;\n$dark-gray3: #9CA2A9;\n$error-red: #EF3838;\n$success-green : #AAFE3F;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
